import React from 'react';

import {
    SprayEntityIds,
    SprayEventTotalArea
} from 'services/sprayEvents/types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { AppState } from 'services/types';

// Selectors
import { makeSelectTotalArea } from './selectors';

interface ConnectedProps {
    totalArea?: SprayEventTotalArea;
}

export interface OwnProps {
    entityIds: SprayEntityIds;
}

export type Props = OwnProps & ConnectedProps;

export class TotalAreaFieldComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { totalArea } = this.props;

        return (
            <div className="field" style={{ margin: 0 }}>
                <label htmlFor="totalArea">
                    Total Area: <span>{totalArea} Ha</span>
                </label>
            </div>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    totalArea: makeSelectTotalArea()
});

export default connect(mapStateToProps)(TotalAreaFieldComponent);
